import { Component } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RecaptchaModule } from "ng-recaptcha";
import { ImportsModule } from "../../../../imports";
import { LenguageSwitcher } from "../../../shared/lenguage-switcher/lenguage-switcher";
import { LoginBaseComponent } from "../login.base.component";
import { ReloginScreenComponent } from "../reloginscreen.component";

@Component({
    standalone:true,
    selector: 'app-login-solpol',
    templateUrl: `login.solpol.component.html`,
    styleUrls: ['./login.solpol.component.scss'],
    imports: [FormsModule, RecaptchaModule, ImportsModule, LenguageSwitcher,ReloginScreenComponent],
})
export class LoginSolpolComponent extends LoginBaseComponent {

}